import { Component, Host, h, Prop, Element, Event, EventEmitter } from '@stencil/core';

@Component({
    tag: 'sew-dialog',
    styleUrl: 'sew-dialog.scss',
    shadow: true,
})
export class SewDialog {
    @Element() public el: HTMLSewDialogElement;
    /**
     * Sets the styles to the sew-ws theme. Default is false.
     */
    @Prop() ws = false;
    @Prop({ reflect: true }) type = 'info';
    @Prop() headline: string;
    @Prop() label?: string;
    @Prop() status: string;
    @Prop() closeButton: boolean;
    @Prop({ reflect: true }) open: boolean;
    @Prop({ reflect: true }) size = 'xs';
    @Event() close: EventEmitter<boolean>;

    private iconMapping = {
        'info': 'info-filled',
        'attention': 'info-filled',
        'warning': 'warning-filled',
        'warning-ansi': 'warning-filled',
        'error': 'wrong-filled',
        'valid': 'check-circle-filled',
    };

    componentWillLoad(): void {
        this.el.querySelectorAll('sew-video[autoplay]').forEach(video => {
            const vid = video as HTMLSewVideoElement;

            vid.removeAttribute('autoplay');
            vid.setAttribute('data-autoplay', 'true');
        });

        document.addEventListener('keydown', this.closeOnEscape);
    }

    private closeOnEscape = (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
            this.closeDialog();
        }
    };

    componentWillRender(): void {
        if (this.open) {
            document.body.classList.add('sew-modal-open');
            this.el
                .querySelectorAll('sew-video[data-autoplay]')
                .forEach(video => (video as HTMLSewVideoElement).startVideo());
        } else {
            document.body.classList.remove('sew-modal-open');
        }

        this.el.addEventListener('buttonIsSqueezed', () => {
            this.el.classList.add('squeezed-buttons');
        });
    }

    private closeDialog() {
        document.body.classList.remove('sew-modal-open');
        this.open && this.close.emit(true);
        this.open = false;
        this.el.querySelectorAll('sew-video').forEach(video => video.pauseVideo());
    }

    disconnectedCallback(): void {
        document.removeEventListener('keydown', this.closeOnEscape);
        this.open = false;
        this.closeDialog();
    }

    render() {
        // TODO: test with non ws dialog
        const buttons = this.el.querySelectorAll<HTMLSewWsButtonElement>('[slot="button"]');
        const hasButtons = buttons.length > 0;
        buttons.forEach(button => {
            button.ellipsis = false;
        });

        return (
            <Host class={{ 'sew-ws': this.ws }}>
                <div class="grid">
                    <div class="dialog-wrapper">
                        <div
                            class={{
                                dialog: true,
                                ...(this.status !== null ? { 'status-border': !this.status } : {}),
                            }}
                        >
                            {this.status && (
                                <div class="status">
                                    <sew-icon class="svg" icon={this.iconMapping[this.type]} />
                                    {this.status}
                                </div>
                            )}
                            <div
                                class={{ 'content': true, 'has-headlines': !!this.label || !!this.headline }}
                            >
                                {this.label && <div class="label">{this.label}</div>}
                                <div class="headline-wrapper">
                                    {this.headline && <h3 innerHTML={this.headline}></h3>}
                                    <slot name="help"></slot>
                                </div>
                                {this.closeButton && (
                                    <button
                                        onClick={() => {
                                            this.closeDialog();
                                        }}
                                    >
                                        <sew-icon icon="close" />
                                    </button>
                                )}
                                <slot></slot>
                            </div>
                            {hasButtons && <slot name="button"></slot>}
                        </div>
                    </div>
                </div>
            </Host>
        );
    }
}
